import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { BaseEventTracking } from '@/modules/core/app/models/abstracts/BaseEventTracking';

export class AnnouncementDisplayed extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ANNOUNCEMENT_DISPLAYED;

  announcementId: number;

  constructor(announcementId: number) {
    super();

    this.announcementId = announcementId;
  }
}
